export default "__VITE_ASSET__Cix49Bdp__"